<ng-container *ngIf="profileReady">
<!-- <div class="d-flex flex-column gap-3 px-0 align-items-center m-5 mt-4" style="height: calc(100vh - 110px);"> -->
  <!-- <div class="text-center w-100"> -->
    <div class="shadow-lg rounded-4 step-body-scroll px-4 py-3 pt-5" [ngClass]="[ fromPopup ? 'w-100' : 'w-50' ]" [style.margin]="fromPopup ? '0' : '3vh 25vw'" 
        [style.height]="fromPopup ? '100vh' : '80vh'"
         style="backdrop-filter: blur(10px); background: rgba(255,255,255,0.8); ">

      <!-- Close Button -->
      

      <!-- Content -->
      <div class="container-fluid">
        <!-- Profile Completion Bar -->
        <!-- <div class="row" *ngIf="!fromPopup">
          <div class="col-12 mb-4">
            <div class="checklist-progress d-flex align-items-center">
              <div style="flex-grow: 1; height: 10px; background-color: #e0e0e0; border-radius: 5px; overflow: hidden;">
                <div [ngStyle]="{ 'width': calculateProfileCompletion + '%' }"
                     style="height: 100%; background-color: #008A70;"></div>
              </div>
              <span style="margin-left: 10px; color: #205567; font-weight: bold;">
                {{ calculateProfileCompletion }}%
              </span>
            </div>
          </div>
        </div> -->
        
        <div class="row">
          
          <div class="col-2">

              <!-- Profile Image -->
                <div class="w-100 d-flex justify-content-center">
                  <input type="file" (change)="onFileSelected($event)" [disabled]="fromPopup"
                         style="display: none;" #fileInput>

                  <div (mouseover)="!fromPopup && (showUploadButton = true)"
                       (mouseout)="!fromPopup && (showUploadButton = false)"
                       style="width: 120px; aspect-ratio: 1; background-color: #008A70; border-radius: 50%;
                              background-image: url('data:image/png;base64,{{ userDetails.displayImageBytes }}');
                              background-size: cover; background-position: center;">

                    <div class="d-flex align-content-center justify-content-center"
                         [attr.title]="fromPopup ? 'Profile editing disabled in preview' : null"
                         [style.cursor]="fromPopup ? 'not-allowed' : 'pointer'"
                         style="position: relative; width: 100%; height: 100%;"
                         (click)="!fromPopup && fileInput.click()">

                      <div *ngIf="!userDetails?.displayImageBytes"
                        class="initials-avatar">
                        {{ dataService.initials }}
                        </div>

                      <!-- Upload Icon -->
                      <div *ngIf="!fromPopup && showUploadButton"
                           class="d-flex h-100 w-100 d-flex align-items-center justify-content-center"
                           style="border-radius: 50%; position: absolute; z-index: 1; background-color: black; opacity: .5;">
                        <!-- <mat-icon *ngIf="showUploadButton"
                                  class="h-100 w-100 d-flex align-items-center justify-content-center"
                                  style="color: #205567; font-size: 4em;">upload</mat-icon> -->
                                  <!-- <div class="h-100 w-100 d-flex align-items-center justify-content-center" > -->
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_858_9400)">
                                        <path d="M29.5348 5L27.1798 1.94667C26.7107 1.34301 26.1104 0.854028 25.4243 0.516757C24.7382 0.179486 23.9843 0.00277174 23.2198 0L16.7798 0C16.0153 0.00277174 15.2615 0.179486 14.5754 0.516757C13.8893 0.854028 13.289 1.34301 12.8198 1.94667L10.4648 5H29.5348Z" fill="white"/>
                                        <path d="M19.9997 30C23.6816 30 26.6663 27.0152 26.6663 23.3333C26.6663 19.6514 23.6816 16.6667 19.9997 16.6667C16.3178 16.6667 13.333 19.6514 13.333 23.3333C13.333 27.0152 16.3178 30 19.9997 30Z" fill="white"/>
                                        <path d="M31.6667 8.33333H8.33333C6.12401 8.33597 4.00593 9.2148 2.4437 10.777C0.88147 12.3393 0.00264643 14.4573 0 16.6667L0 31.6667C0.00264643 33.876 0.88147 35.9941 2.4437 37.5563C4.00593 39.1185 6.12401 39.9974 8.33333 40H31.6667C33.876 39.9974 35.9941 39.1185 37.5563 37.5563C39.1185 35.9941 39.9974 33.876 40 31.6667V16.6667C39.9974 14.4573 39.1185 12.3393 37.5563 10.777C35.9941 9.2148 33.876 8.33597 31.6667 8.33333ZM20 33.3333C18.0222 33.3333 16.0888 32.7468 14.4443 31.648C12.7998 30.5492 11.5181 28.9874 10.7612 27.1602C10.0043 25.3329 9.80629 23.3222 10.1921 21.3824C10.578 19.4426 11.5304 17.6608 12.9289 16.2623C14.3275 14.8637 16.1093 13.9113 18.0491 13.5255C19.9889 13.1396 21.9996 13.3377 23.8268 14.0945C25.6541 14.8514 27.2159 16.1331 28.3147 17.7776C29.4135 19.4221 30 21.3555 30 23.3333C29.9974 25.9847 28.9429 28.5267 27.0681 30.4015C25.1934 32.2763 22.6514 33.3307 20 33.3333Z" fill="white"/>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_858_9400">
                                          <rect width="40" height="40" fill="white"/>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>

          </div>

          <div class="col d-flex flex-column justify-content-center">

              <div class="row">
                <div class="col">
                                        <button *ngIf="!fromPopup" class="btn p-0 position-absolute d-flex align-items-center justify-content-center" 
                                        style="top: 15px; right: 15px; width: 24px; height: 24px; background: #000000; border: none; border-radius: 50%;" 
                                        (click)="closePopup()" aria-label="Close">
                                            <mat-icon style="color: white; font-size: 18px; width: 18px; height: 18px; line-height: 18px;">close</mat-icon>
                                        </button>
                  <div class="d-flex justify-content-between">
                    <div class="d-flex gap-3 h-100">
                      <h2 class="m-0" style="font-size: 24px; text-align: left;font-weight: 500;">
                        {{ userDetails.firstName + " " + userDetails.lastName | titlecase }}
                        <p style="color: #707070; font-size: 16px;font-weight: 400;">&commat;{{ userDetails.userId }}</p>
                      </h2>
                      <span
                        [style.background-color]="userDetails.role === 'DOCTOR' ? '#5ECDA71A' : '#FF73401A'"
                        [style.color]="userDetails.role === 'DOCTOR' ? '#5ECDA7' : '#FF7340'"
                       style="border-radius: 4px; height: 34px; align-content: center; " class="badge text-uppercase px-3 py-1" >
                        {{ userDetails.role }}
                      </span>
                    </div>
                    <button *ngIf="!fromPopup" class="btn" style="color: #707070; border-radius: 8px; font-weight: 500; border: 1px solid #E4E4E4; height: 42px;" (click)="editUser()">
                        Edit
                    </button>

<!--                    <button *ngIf="!fromPopup" class="btn" style="color: #707070; border-radius: 8px; font-weight: 500; border: 1px solid #E4E4E4; height: 42px;" (click)="closePopup()">-->
<!--                        Close-->
<!--                    </button>-->
                  </div>
                </div>
              </div>


               <div class="row">
                <div class="col d-flex flex-wrap gap-3 align-items-center" style="color: #707070;">

                  <div class="d-flex align-items-center gap-2">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_737_9247)">
                        <path d="M10.0003 5C9.34106 5 8.69659 5.1955 8.14843 5.56177C7.60026 5.92804 7.17302 6.44863 6.92073 7.05772C6.66844 7.66681 6.60243 8.33703 6.73104 8.98363C6.85966 9.63024 7.17713 10.2242 7.6433 10.6904C8.10948 11.1565 8.70342 11.474 9.35003 11.6026C9.99663 11.7312 10.6669 11.6652 11.2759 11.4129C11.885 11.1606 12.4056 10.7334 12.7719 10.1852C13.1382 9.63707 13.3337 8.9926 13.3337 8.33333C13.3337 7.44928 12.9825 6.60143 12.3574 5.97631C11.7322 5.35119 10.8844 5 10.0003 5ZM10.0003 10C9.67069 10 9.34846 9.90225 9.07438 9.71912C8.8003 9.53598 8.58667 9.27568 8.46053 8.97114C8.33438 8.6666 8.30138 8.33149 8.36569 8.00818C8.42999 7.68488 8.58873 7.38791 8.82182 7.15482C9.0549 6.92174 9.35188 6.763 9.67518 6.69869C9.99848 6.63438 10.3336 6.66739 10.6381 6.79353C10.9427 6.91968 11.203 7.1333 11.3861 7.40738C11.5692 7.68147 11.667 8.0037 11.667 8.33333C11.667 8.77536 11.4914 9.19928 11.1788 9.51184C10.8663 9.82441 10.4424 10 10.0003 10Z" fill="#707070"/>
                        <path d="M10.0003 20C9.29855 20.0036 8.60619 19.839 7.98115 19.52C7.35611 19.2011 6.81659 18.737 6.40776 18.1667C3.23193 13.7858 1.62109 10.4925 1.62109 8.3775C1.62109 6.15521 2.5039 4.02394 4.07529 2.45254C5.64669 0.881139 7.77797 -0.00166321 10.0003 -0.00166321C12.2226 -0.00166321 14.3538 0.881139 15.9252 2.45254C17.4966 4.02394 18.3794 6.15521 18.3794 8.3775C18.3794 10.4925 16.7686 13.7858 13.5928 18.1667C13.1839 18.737 12.6444 19.2011 12.0194 19.52C11.3943 19.839 10.702 20.0036 10.0003 20ZM10.0003 1.8175C8.26061 1.81949 6.59278 2.51144 5.36265 3.74156C4.13253 4.97168 3.44058 6.63952 3.43859 8.37917C3.43859 10.0542 5.01609 13.1517 7.87943 17.1008C8.12251 17.4357 8.4414 17.7082 8.81002 17.8961C9.17864 18.084 9.58651 18.1819 10.0003 18.1819C10.414 18.1819 10.8219 18.084 11.1905 17.8961C11.5591 17.7082 11.878 17.4357 12.1211 17.1008C14.9844 13.1517 16.5619 10.0542 16.5619 8.37917C16.5599 6.63952 15.868 4.97168 14.6379 3.74156C13.4077 2.51144 11.7399 1.81949 10.0003 1.8175Z" fill="#707070"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_737_9247">
                          <rect width="20" height="20" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>

                    <span>Lives in: {{userLocation}}</span>
                  </div>

                  <div class="d-flex align-items-center gap-2">

                    <svg class="d-none d-xl-block" width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="2" cy="2" r="2" fill="#707070"/>
                    </svg>

                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_737_9257)">
                        <path d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34872 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM17.2058 5.83333H14.5217C13.9208 4.44082 13.1297 3.1384 12.1708 1.96333C14.2929 2.54077 16.1019 3.93122 17.2058 5.83333ZM13.75 10C13.7432 10.8484 13.6095 11.6911 13.3533 12.5H6.64667C6.39055 11.6911 6.25685 10.8484 6.25 10C6.25685 9.15155 6.39055 8.3089 6.64667 7.5H13.3533C13.6095 8.3089 13.7432 9.15155 13.75 10ZM7.315 14.1667H12.685C11.9777 15.5631 11.0735 16.8507 10 17.99C8.92615 16.851 8.02187 15.5634 7.315 14.1667ZM7.315 5.83333C8.02231 4.43689 8.92654 3.1493 10 2.01C11.0739 3.14898 11.9781 4.43663 12.685 5.83333H7.315ZM7.83334 1.96333C6.87305 3.13815 6.08049 4.44058 5.47834 5.83333H2.79417C3.89905 3.93036 5.70972 2.5398 7.83334 1.96333ZM2.05084 7.5H4.91667C4.70064 8.31595 4.58864 9.15595 4.58334 10C4.58864 10.8441 4.70064 11.684 4.91667 12.5H2.05084C1.53862 10.8727 1.53862 9.12731 2.05084 7.5ZM2.79417 14.1667H5.47834C6.08049 15.5594 6.87305 16.8618 7.83334 18.0367C5.70972 17.4602 3.89905 16.0696 2.79417 14.1667ZM12.1708 18.0367C13.1297 16.8616 13.9208 15.5592 14.5217 14.1667H17.2058C16.1019 16.0688 14.2929 17.4592 12.1708 18.0367ZM17.9492 12.5H15.0833C15.2994 11.684 15.4114 10.8441 15.4167 10C15.4114 9.15595 15.2994 8.31595 15.0833 7.5H17.9475C18.4597 9.12731 18.4597 10.8727 17.9475 12.5H17.9492Z" fill="#707070"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_737_9257">
                          <rect width="20" height="20" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>

                    <span>Preferred language: {{languageCodeMap[userDetails.prefLangCd]}}</span>
                  </div>

                  <div class="d-flex align-items-center gap-2">
                    <svg class="d-none d-xl-block" width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="2" cy="2" r="2" fill="#707070"/>
                    </svg>

                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_737_9278)">
                        <path d="M19.1667 18.3333H18.3333V11.6667C18.332 10.562 17.8926 9.50296 17.1115 8.72185C16.3304 7.94073 15.2713 7.50132 14.1667 7.5H10.8333V5.0325C11.2046 4.87048 11.5205 4.60376 11.7425 4.26498C11.9645 3.92619 12.083 3.53004 12.0833 3.12499C11.8582 2.05981 11.3511 1.07465 10.615 0.272495C10.5369 0.187103 10.4419 0.118906 10.336 0.0722489C10.2301 0.0255914 10.1157 0.00149536 10 0.00149536C9.88429 0.00149536 9.76985 0.0255914 9.66397 0.0722489C9.55809 0.118906 9.46308 0.187103 9.385 0.272495C8.64889 1.07465 8.14178 2.05981 7.91667 3.12499C7.91704 3.53004 8.03547 3.92619 8.25748 4.26498C8.47949 4.60376 8.79544 4.87048 9.16667 5.0325V7.5H5.83333C4.72867 7.50132 3.66963 7.94073 2.88852 8.72185C2.1074 9.50296 1.66799 10.562 1.66667 11.6667V18.3333H0.833333C0.61232 18.3333 0.400358 18.4211 0.244078 18.5774C0.0877974 18.7337 0 18.9456 0 19.1667C0 19.3877 0.0877974 19.5996 0.244078 19.7559C0.400358 19.9122 0.61232 20 0.833333 20H19.1667C19.3877 20 19.5996 19.9122 19.7559 19.7559C19.9122 19.5996 20 19.3877 20 19.1667C20 18.9456 19.9122 18.7337 19.7559 18.5774C19.5996 18.4211 19.3877 18.3333 19.1667 18.3333ZM5.83333 9.16666H14.1667C14.8297 9.16666 15.4656 9.43005 15.9344 9.89889C16.4033 10.3677 16.6667 11.0036 16.6667 11.6667V13.3167C15.8867 13.2333 15.4167 12.7333 15.4167 12.5C15.4167 12.279 15.3289 12.067 15.1726 11.9107C15.0163 11.7545 14.8043 11.6667 14.5833 11.6667C14.3623 11.6667 14.1504 11.7545 13.9941 11.9107C13.8378 12.067 13.75 12.279 13.75 12.5C13.75 12.7858 13.1817 13.3333 12.2917 13.3333C11.3842 13.3333 10.8333 12.755 10.8333 12.5C10.8333 12.279 10.7455 12.067 10.5893 11.9107C10.433 11.7545 10.221 11.6667 10 11.6667C9.77899 11.6667 9.56702 11.7545 9.41074 11.9107C9.25446 12.067 9.16667 12.279 9.16667 12.5C9.16667 12.7858 8.59833 13.3333 7.70833 13.3333C6.80083 13.3333 6.25 12.755 6.25 12.5C6.25 12.279 6.1622 12.067 6.00592 11.9107C5.84964 11.7545 5.63768 11.6667 5.41667 11.6667C5.19565 11.6667 4.98369 11.7545 4.82741 11.9107C4.67113 12.067 4.58333 12.279 4.58333 12.5C4.58333 12.7625 4.10083 13.24 3.33333 13.3175V11.6667C3.33333 11.0036 3.59673 10.3677 4.06557 9.89889C4.53441 9.43005 5.17029 9.16666 5.83333 9.16666ZM3.33333 14.9825C4.09891 14.9485 4.83161 14.6616 5.41667 14.1667C6.05947 14.7025 6.86924 14.997 7.70608 14.9993C8.54292 15.0016 9.35428 14.7115 10 14.1792C10.6457 14.7115 11.4571 15.0016 12.2939 14.9993C13.1308 14.997 13.9405 14.7025 14.5833 14.1667C15.1685 14.6613 15.9012 14.9479 16.6667 14.9817V18.3333H3.33333V14.9825Z" fill="#707070"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_737_9278">
                          <rect width="20" height="20" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>

                    <span>Since 2025 on Gity</span>
                  </div>

                </div>

              </div>

          </div>

        </div>


        <div class="row mt-4">
            <div class="col">
                <button *ngIf="fromPopup" class="btn w-100" style="border-radius: 8px; font-weight: 500; border: 1px solid #E4E4E4; height: 42px;" (click)="saveUser()">
                  <svg *ngIf="!isFav" width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.0835 0.597534C14.1451 0.61213 13.2272 0.874079 12.4224 1.35693C11.6177 1.83977 10.9546 2.52642 10.5001 3.34753C10.0457 2.52642 9.38257 1.83977 8.57783 1.35693C7.77308 0.874079 6.85517 0.61213 5.91679 0.597534C4.42091 0.662526 3.01155 1.31691 1.99661 2.41773C0.981678 3.51854 0.443669 4.97631 0.500128 6.47253C0.500128 10.2617 4.48846 14.4 7.83346 17.2059C8.58031 17.8335 9.52459 18.1776 10.5001 18.1776C11.4757 18.1776 12.4199 17.8335 13.1668 17.2059C16.5118 14.4 20.5001 10.2617 20.5001 6.47253C20.5566 4.97631 20.0186 3.51854 19.0036 2.41773C17.9887 1.31691 16.5793 0.662526 15.0835 0.597534ZM12.096 15.9309C11.6493 16.307 11.0841 16.5133 10.5001 16.5133C9.91617 16.5133 9.35098 16.307 8.90429 15.9309C4.62263 12.3384 2.16679 8.8917 2.16679 6.47253C2.10983 5.41813 2.4721 4.38398 3.1746 3.59562C3.87709 2.80726 4.86282 2.32866 5.91679 2.2642C6.97077 2.32866 7.95649 2.80726 8.65899 3.59562C9.36149 4.38398 9.72376 5.41813 9.66679 6.47253C9.66679 6.69355 9.75459 6.90551 9.91087 7.06179C10.0672 7.21807 10.2791 7.30587 10.5001 7.30587C10.7211 7.30587 10.9331 7.21807 11.0894 7.06179C11.2457 6.90551 11.3335 6.69355 11.3335 6.47253C11.2765 5.41813 11.6388 4.38398 12.3413 3.59562C13.0438 2.80726 14.0295 2.32866 15.0835 2.2642C16.1374 2.32866 17.1232 2.80726 17.8257 3.59562C18.5282 4.38398 18.8904 5.41813 18.8335 6.47253C18.8335 8.8917 16.3776 12.3384 12.096 15.9275V15.9309Z" fill="black"/>
                  </svg>  
                  <svg *ngIf="isFav" width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.5835 0.597473C13.6451 0.612069 12.7272 0.874017 11.9224 1.35687C11.1177 1.83971 10.4546 2.52636 10.0001 3.34747C9.54566 2.52636 8.88257 1.83971 8.07783 1.35687C7.27308 0.874017 6.35517 0.612069 5.41679 0.597473C3.92091 0.662465 2.51155 1.31685 1.49661 2.41767C0.481678 3.51848 -0.0563308 4.97624 0.000128002 6.47247C0.000128002 10.2616 3.98846 14.4 7.33346 17.2058C8.08031 17.8334 9.02459 18.1775 10.0001 18.1775C10.9757 18.1775 11.9199 17.8334 12.6668 17.2058C16.0118 14.4 20.0001 10.2616 20.0001 6.47247C20.0566 4.97624 19.5186 3.51848 18.5036 2.41767C17.4887 1.31685 16.0793 0.662465 14.5835 0.597473Z" fill="#5ECDA7"/>
                  </svg>
                  Save
                </button>
            </div>
            <div class="col">
                <button *ngIf="fromPopup" class="btn w-100" style="color: #FFFFFF; background-color: #000000; border-radius: 8px; font-weight: 500; border: 1px solid #E4E4E4; height: 42px;" (click)="createTask()">
                    Create task
                </button>
            </div>
        </div>

        <hr style="border: 1px solid #E4E4E4;">
       

        <div class="row mb-4">
          <div class="col">
            <h3>Overview</h3>
          </div>
        </div>


        <div class="row">
          <div class="col-auto" *ngIf="userDetails.role === 'DESIGNER'">
            <div class="mb-0 d-flex gap-2">
              <h4 class="mb-0">{{ stats.ratings }}</h4>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.9374 8.70634C23.7803 8.22036 23.3493 7.8752 22.8393 7.82924L15.9123 7.20026L13.1731 0.789021C12.9712 0.319161 12.5112 0.0150146 12.0001 0.0150146C11.4891 0.0150146 11.0291 0.319161 10.8271 0.79012L8.08797 7.20026L1.15982 7.82924C0.65077 7.8763 0.220828 8.22036 0.0628038 8.70634C-0.0952203 9.19231 0.0507185 9.72534 0.435799 10.0614L5.67183 14.6534L4.12785 21.4546C4.01487 21.9547 4.20897 22.4716 4.62389 22.7716C4.84692 22.9327 5.10785 23.0147 5.37098 23.0147C5.59786 23.0147 5.8229 22.9536 6.02487 22.8327L12.0001 19.2615L17.9732 22.8327C18.4103 23.0957 18.9612 23.0717 19.3752 22.7716C19.7904 22.4707 19.9843 21.9536 19.8713 21.4546L18.3273 14.6534L23.5633 10.0623C23.9484 9.72534 24.0955 9.19323 23.9374 8.70634Z" fill="#5ECDA7"/>
              </svg>
            </div>
            <p style="color: #707070;">{{ stats.ratingsCount }} ratings</p>
          </div>

          <div class="col-auto" *ngIf="userDetails.role === 'DESIGNER'">
            <svg width="1" height="52" viewBox="0 0 1 52" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="0.5" y1="6.1057e-05" x2="0.499998" y2="52.0001" stroke="#E4E4E4"/>
            </svg>
          </div>

          <div class="col-auto" *ngIf="userDetails.role === 'DESIGNER'">
            <div class="mb-0 d-flex gap-2">
              <h4 class="mb-0">{{ stats.ordersCount }}</h4>
            </div>
            <p style="color: #707070;">Total orders</p>
          </div>

          <div class="col-auto" *ngIf="userDetails.role === 'DESIGNER'">
            <svg width="1" height="52" viewBox="0 0 1 52" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="0.5" y1="6.1057e-05" x2="0.499998" y2="52.0001" stroke="#E4E4E4"/>
            </svg>
          </div>

          <div class="col-auto" *ngIf="userDetails.role === 'DESIGNER'">
            <div class="mb-0 d-flex gap-2 align-items-end">
              <h4 class="mb-0">{{ userDetails.experience }}</h4>
              <!-- <p class="m-0">Years</p> -->
            </div>
            <p style="color: #707070;">Years experience</p>
          </div>

        </div>


        <div *ngIf="userDetails.role === 'DESIGNER'">

            <div class="row mt-3">
              <div class="col">
                <h5>Software</h5>
                <span *ngFor="let word of splitValue(getFormattedSoftware(userDetails.software, userDetails.otherSoftware)); let last = last">
                  <svg class="me-2" width="15" height="11" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.20006 11.7834C4.97716 11.7835 4.75643 11.7396 4.55052 11.6543C4.3446 11.5689 4.15754 11.4438 4.00006 11.286L0.292725 7.58071L1.70739 6.16671L5.20006 9.65938L14.2927 0.566711L15.7074 1.98071L6.40006 11.286C6.24257 11.4438 6.05552 11.5689 5.8496 11.6543C5.64369 11.7396 5.42296 11.7835 5.20006 11.7834Z" fill="black"/>
                  </svg>
                  <span>{{ word }}</span>
                  <span *ngIf="!last" class="mx-3">
                    <svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="2" cy="2.50006" r="2" fill="black"/>
                    </svg>
                  </span>
                </span>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <h5>Professional Skills</h5>
                <span *ngFor="let word of splitValue(userDetails.primarySkill); let last = last">
                  <svg class="me-2" width="15" height="11" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.20006 11.7834C4.97716 11.7835 4.75643 11.7396 4.55052 11.6543C4.3446 11.5689 4.15754 11.4438 4.00006 11.286L0.292725 7.58071L1.70739 6.16671L5.20006 9.65938L14.2927 0.566711L15.7074 1.98071L6.40006 11.286C6.24257 11.4438 6.05552 11.5689 5.8496 11.6543C5.64369 11.7396 5.42296 11.7835 5.20006 11.7834Z" fill="black"/>
                  </svg>
                  <span>{{ word }}</span>
                  <span *ngIf="!last" class="mx-3">
                    <svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="2" cy="2.50006" r="2" fill="black"/>
                    </svg>
                  </span>
                </span>
              </div>
            </div>

            <div class="row mt-4" style="color: #707070;">
              <div class="col">
                <p class="mb-1" style="font-size: 15px;">Additional Skills</p>
                <span style="font-size: 13px;" *ngFor="let word of splitValue(userDetails.additionalSkill); let last = last">
                  <svg class="me-2" width="15" height="11" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.20006 11.7834C4.97716 11.7835 4.75643 11.7396 4.55052 11.6543C4.3446 11.5689 4.15754 11.4438 4.00006 11.286L0.292725 7.58071L1.70739 6.16671L5.20006 9.65938L14.2927 0.566711L15.7074 1.98071L6.40006 11.286C6.24257 11.4438 6.05552 11.5689 5.8496 11.6543C5.64369 11.7396 5.42296 11.7835 5.20006 11.7834Z" fill="black"/>
                  </svg>
                  <span>{{ word }}</span>
                  <span *ngIf="!last" class="mx-3">
                    <svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="2" cy="2.50006" r="2" fill="black"/>
                    </svg>
                  </span>
                </span>
              </div>
            </div>

          

            <div class="row mt-4" *ngIf="potfolioImagesData.length > 0">
              <div class="col">
                <h3>Portfolio</h3>
                <div class="d-flex gap-3 overflow-y-auto">
                  <div *ngFor="let image of potfolioImagesData" class="portfolio-image-item" style="text-align: left;">
                    <img [src]="image.content"  style="width: 200px; border-radius: 8px; border: 1px solid #E4E4E4;"/>
                    <!-- (click)="previewImage(image.name)"    cursor: pointer;    -->
                  </div>
                </div>
              </div>
            </div>


        </div>

        

        <div class="row mt-4">
          <div class="col">
            <h3>About {{ userDetails.firstName }}</h3>
            <p style="color: #707070;">{{ userDetails.about }}</p>
          </div>
        </div>



<!-- 
        <div class="row">
          <div class="col-12 col-lg-6 col-xl-5 col-xxl-3 mb-2">
            <div class="d-flex flex-column gap-3 w-100 px-3 py-5 rounded-4 shadow-sm bg-light">
              <div class="d-flex flex-column align-items-start gap-2 justify-content-center">
                <div class="w-100 d-flex justify-content-center">
                  <input type="file" (change)="onFileSelected($event)" [disabled]="fromPopup"
                         style="display: none;" #fileInput>

                  <div (mouseover)="!fromPopup && (showUploadButton = true)"
                       (mouseout)="!fromPopup && (showUploadButton = false)"
                       [style.opacity]="showUploadButton ? '0.5' : '1'"
                       style="width: 200px; aspect-ratio: 1; background-color: #008A70; border-radius: 50%;
                              background-image: url('data:image/png;base64,{{ userDetails.displayImageBytes }}');
                              background-size: cover; background-position: center;">

                    <div class="d-flex align-content-center justify-content-center"
                         [attr.title]="fromPopup ? 'Profile editing disabled in preview' : null"
                         [style.cursor]="fromPopup ? 'not-allowed' : 'pointer'"
                         style="position: relative; width: 100%; height: 100%;"
                         (click)="!fromPopup && fileInput.click()">

                      <div class="d-flex align-items-center h-100"
                           *ngIf="!userDetails?.displayImageBytes"
                           style="color:#205567; font-size: 5em; line-height: 100px; position: absolute;">
                        <span>{{ dataService.initials }}</span>
                      </div>

                      <div *ngIf="!fromPopup"
                           class="d-flex align-items-center h-100 w-100"
                           style="position: absolute; z-index: 1;">
                        <mat-icon *ngIf="showUploadButton"
                                  class="h-100 w-100 d-flex align-items-center justify-content-center"
                                  style="color: #205567; font-size: 4em;">upload</mat-icon>
                      </div>
                    </div>
                  </div>
                </div>

                 <div class="w-100 d-flex justify-content-center">
                  <span style="font-size: 1.5em; color: #008A70;">
                    <ng-container *ngFor="let star of [1, 2, 3, 4];">
                      @if(ratings >= star){
                        <mat-icon>star</mat-icon>
                      } @else if(star - ratings < 1){
                        <mat-icon>star_half</mat-icon>
                      } @else{
                        <mat-icon>star_border</mat-icon>
                      }
                    </ng-container>
                  </span>
                </div> 
              </div>

              <div class="d-flex flex-column gap-2 w-100 ;padding-left: -0.5rem!important " style="color: #205567;">
                <div class="d-flex align-items-center gap-1">
                  <span style="color:#008A70;"><mat-icon>home</mat-icon></span> {{ userLocation }}
                </div>
                <div class="d-flex align-items-center gap-1">
                  <span style="color:#008A70;"><mat-icon>work</mat-icon></span> {{ userDetails.role }}
                </div>
                <div class="d-flex align-items-center gap-1">
                  <span style="color:#008A70;"><mat-icon>person</mat-icon></span> {{ userDetails.userId }}
                </div>
                <div class="d-flex align-items-center gap-1" style="white-space: nowrap;">
                  <span style="color:#008A70;"><mat-icon>calendar_month</mat-icon></span>
                  <span>{{ userDetails.lastLogin }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6 col-xl-7 col-xxl-9 mb-5">
            <div class="d-flex flex-column w-100" style="color: #205567;">
              <div class="d-flex justify-content-between">
                <h2 class="m-0" style="font-size: 24px; font-weight: bold; text-align: left;">
                  {{ userDetails.firstName }} {{ userDetails.lastName }}
                </h2>
                <button *ngIf="!fromPopup"
                        class="customPreActivatedButtons p-1 d-flex align-items-center"
                        (click)="editUser()">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>

              <div class="h-100 d-flex flex-column justify-content-between">
                <div>
                  <div class="checklist-item" style="padding: 15px 0; border-bottom: 1px solid #C5E2DA;">
                    <h4 class="m-0" style="font-size: 16px; font-weight: bold; text-align: left;">Primary Skill</h4>
                    <p class="m-0 mt-1" style="font-size: 14px; color: #898989; text-align: left;">{{ userDetails.primarySkill }}</p>
                  </div>

                  <div class="checklist-item" style="padding: 15px 0; border-bottom: 1px solid #C5E2DA;">
                    <h4 class="m-0" style="font-size: 16px; font-weight: bold; text-align: left;">Additional Skill</h4>
                    <p class="m-0 mt-1" style="font-size: 14px; color: #898989; text-align: left;">{{ userDetails.additionalSkill }}</p>
                  </div>

                  <div class="checklist-item" style="padding: 15px 0; border-bottom: 1px solid #C5E2DA;">
                    <h4 class="m-0" style="font-size: 16px; font-weight: bold; text-align: left;">Profile Text</h4>
                    <p class="m-0 mt-1" style="font-size: 14px; color: #898989; text-align: left;">{{ userDetails.about }}</p>
                  </div>

                  <div class="checklist-item" style="padding: 15px 0; border-bottom: 1px solid #C5E2DA;">
                    <h4 class="m-0" style="font-size: 16px; font-weight: bold; text-align: left;">Experience</h4>
                    <p class="m-0 mt-1" style="font-size: 14px; color: #898989; text-align: left;">{{ userDetails.experience }}</p>
                  </div>

                  <div class="checklist-item" style="padding: 15px 0; border-bottom: 1px solid #C5E2DA;">
                    <h4 class="m-0" style="font-size: 16px; font-weight: bold; text-align: left;">Software</h4>
                    <p class="m-0 mt-1" style="font-size: 14px; color: #898989;  text-align: left;">
                      {{ getFormattedSoftware(userDetails.software, userDetails.otherSoftware) }}
                    </p>
                  </div>
                  <div class="checklist-item" style="padding: 15px 0; border-bottom: 1px solid #C5E2DA;">
                    <h4 class="m-0" style="font-size: 16px; font-weight: bold; text-align: left;">Portfolio showcase</h4>
                    <div class="portfolio-images-list">
                      <div *ngFor="let image of portfolioImages" class="portfolio-image-item" style="text-align: left;">
                        <span style="vertical-align: super;">
                          - <a href="javascript:void(0)"
                               (click)="previewImage(image)"
                               style="color: #205567; text-decoration: underline; cursor: pointer;">
                            {{ image }}
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>



                <div *ngIf="dataService.role === 'designer'" class="d-flex justify-content-between align-items-center mt-3">
                  <a [routerLink]="['/user-test']" style="color: #205567; text-decoration: underline;">
                    <button class="customPreActivatedButtons" type="submit">Assessment Details</button>
                  </a>
                </div>
              </div>
              
            </div>
          </div>
        </div>  -->




      </div> 
      <!-- <div class="d-flex justify-content-end" *ngIf="fromPopup">
        <button mat-icon-button (click)="closePopup()" class="customPreCreateTaskButtons">
          close
        </button>
      </div> -->
    </div> 
    
<!-- </div> -->
</ng-container>